import React, { useEffect, useState, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { getProducts } from '../api/apiendpoint';
import ProductGrid from '../components/ProductGrid';
import { useCart } from '../context/CartContext';
import 'bootstrap/dist/css/bootstrap.min.css';
import  Fruits from '../images/fruits-1114060_1280.jpg';
import Veg from '../images/vegetables-573961_1280.jpg'
import Precut from '../images/vegetables-573961_1280.jpg';
import Butchery from '../images/bacon-586624_1280.jpg';
import Dairy from '../images/dairy.jpg';
import FreshHerbs from '../images/precut.jpg'; 
import Bakery  from '../images/bakery.jpg';// Adjust the path as necessary


const categoryBanners = {
  FRUITS: Fruits,
  VEGETABLES: Veg,
  'PRE-CUT VEGETABLES': Precut,
  BUTCHERY: Butchery,
  DAIRY: Dairy,
  'FRESH HERBS': FreshHerbs,
  BAKERY: Bakery,

};

const CategoryView = () => {
  const { categoryName } = useParams();
  const [products, setProducts] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const productsPerPage = 8;
  const { addToCart } = useCart();

  // Create a ref to the container you want to scroll to
  const productSectionRef = useRef(null);

  useEffect(() => {
    const fetchData = async () => {
      const allProducts = await getProducts();
      const filteredProducts = allProducts.filter(product =>
        product.category?.name_category?.toUpperCase() === categoryName.toUpperCase()
      );

      const formatted = filteredProducts.map(p => ({
        id: p.id,
        name: p.product_name,
        image: p.images.length > 0
          ? `https://mysite-dtzs.onrender.com${p.images[0].product_img}`
          : 'https://via.placeholder.com/300x250?text=No+Image',
        originalPrice: parseFloat(p.product_price),
        discountedPrice: parseFloat(p.product_price_discount),
        price: parseFloat(p.product_price_discount) || 0,
        description: p.product_discription || 'No description available.',
      }));

      setProducts(formatted);
      setCurrentPage(1); // Reset page on category change
    };

    fetchData();
  }, [categoryName]);

  const bannerImage = categoryBanners[categoryName.toUpperCase()] || '/images/default-banner.png';

  // Filter and paginate
  const filteredProducts = products.filter(product =>
    product.name.toLowerCase().includes(searchTerm.toLowerCase())
  );
  const totalPages = Math.ceil(filteredProducts.length / productsPerPage);
  const indexOfLastProduct = currentPage * productsPerPage;
  const indexOfFirstProduct = indexOfLastProduct - productsPerPage;
  const currentProducts = filteredProducts.slice(indexOfFirstProduct, indexOfLastProduct);

  // Scroll to the product section smoothly
  const scrollToProducts = () => {
    if (productSectionRef.current) {
      productSectionRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  // Pagination handlers with scroll
  const handlePageClick = (pageNumber) => {
    setCurrentPage(pageNumber);
    scrollToProducts();
  };

  const handleNext = () => {
    if (currentPage < totalPages) {
      setCurrentPage(prev => prev + 1);
      scrollToProducts();
    }
  };

  const handlePrevious = () => {
    if (currentPage > 1) {
      setCurrentPage(prev => prev - 1);
      scrollToProducts();
    }
  };

  return (
    <>
      {/* Banner Section */}
      <div className="container-fluid p-0 ">
        <div
          className="d-flex flex-column align-items-center justify-content-center text-white text-center"
          style={{
            backgroundImage: `url(${bannerImage})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            height: '300px',
            padding: '1rem',
          }}
        >
          <h2 className="display-4 font-weight-bold text-shadow mb-3">
            {categoryName.toUpperCase()}
          </h2>
     
        </div>
      </div>

      {/* Product Section */}
      <div className="container my-5" ref={productSectionRef}>
        <ProductGrid products={currentProducts} addToCart={addToCart} />

        {/* Pagination Controls */}
        {totalPages > 1 && (
          <div className="d-flex justify-content-center mt-4 flex-wrap">
            <button
              className="btn btn-sm btn-outline-secondary mx-1"
              onClick={handlePrevious}
              disabled={currentPage === 1}
            >
              Previous
            </button>
            {[...Array(totalPages)].map((_, i) => (
              <button
                key={i}
                className={`btn btn-sm mx-1 ${currentPage === i + 1 ? 'btn-dark' : 'btn-outline-secondary'}`}
                onClick={() => handlePageClick(i + 1)}
              >
                {i + 1}
              </button>
            ))}
            <button
              className="btn btn-sm btn-outline-secondary mx-1"
              onClick={handleNext}
              disabled={currentPage === totalPages}
            >
              Next
            </button>
          </div>
        )}
      </div>
    </>
  );
};

export default CategoryView;